// File: client/src/components/common/ScrollToTop.jsx
// Scrolls the window to the top whenever the route path changes.
// Fixes the SPA default behavior where navigating between pages keeps the
// previous scroll position (e.g. clicking "Get Rx" from mid-Home lands mid-Booking).

import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    // Instant jump, not smooth — smooth scroll here would look jarring mid-nav.
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
};

export default ScrollToTop;
